import React from 'react';
import { Badge } from 'antd';
import { useTask } from '../context/TaskContext';

const TaskIcon: React.FC = () => {
  const { tasks, setIsDrawerOpen } = useTask();

  const runningTasks = tasks.filter(
    task => task.status === 'pending' || task.status === 'running',
  ).length;

  return (
    <div onClick={() => setIsDrawerOpen(true)} style={{ cursor: 'pointer' }}>
      <Badge count={runningTasks}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 11.5h6m-6 3h6m2.5-9h-11c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2v-11c0-1.1-.9-2-2-2z" />
        </svg>
      </Badge>
    </div>
  );
};

export default TaskIcon;
